import { getAdminAuthHeaders } from './adminApi';

const API_BASE_URL = process.env.REACT_APP_GOTTEA_API_BASE_URL || 'https://gottea-search-5gtrn.ondigitalocean.app';

async function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) {
    throw new Error(body.error || body.message || `Request failed with status ${response.status}`);
  }
  return body.data || body;
}

async function request(path, options = {}) {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  return parseResponse(response);
}

async function requestForm(path, formData, options = {}) {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    method: options.method || 'POST',
    headers: {
      ...authHeaders,
      ...(options.headers || {}),
    },
    body: formData,
  });
  return parseResponse(response);
}

export async function fetchTokenEarningConfig() {
  return request('/loyalty/admin/token-earning-config');
}

export async function updateTokenEarningConfig(payload) {
  return request('/loyalty/admin/token-earning-config', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function uploadTokenEarningIcon(file) {
  const formData = new FormData();
  formData.append('file', file);
  return requestForm('/loyalty/admin/token-earning-icons', formData);
}
